import { Grid } from '@mui/material'
import clsx from 'clsx'
import { CActions, CNoneOption } from '@Constants/common.constant'
import { EAuthReground } from '@Enum/auth.enum'
import {
    MCity,
    MCountry,
    MPOB,
    MState,
    MUser,
    RegroundTypes,
} from '@Models/auth.model'
import {
    ICommonQuery,
    IPageHeaderActions,
    ISelectOptions,
} from '@Models/common.model'
import moment from 'moment'
import ChangePassword from '@Pages/Client/profile/ChangePassword'
import { ChangeEvent, useEffect, useState, Fragment, useRef } from 'react'
import { Controller, useFieldArray, useForm } from 'react-hook-form'
import { connect } from 'react-redux'
import * as Redux from 'redux'
import { APIServices } from '@Services/api.service'
import AuthAction from '@Stores/auth/auth.action'
import ClientProfileActions from '@ClientActions/profile.action'
import BaseDatePicker from '@Components/Form/BaseDatePicker/BaseDatePicker'
import BaseSelect from '@Components/Form/BaseSelect/BaseSelect'
import { RedditTextField } from '@Components/Form/RedditTextField/RedditTextField'
import UploadImage from '@Components/Form/UploadImage/UploadImage'
import PageHeader from '@Components/Pages/PageHeader/PageHeader'
import { CommonService } from '@Services/common.service'
import { FormService } from '@Services/form.service'
import InputMask from 'react-input-mask'
import * as _ from 'lodash'
import BaseCreatableSelect from '@Components/Form/BaseCreatableSelect/BaseCreatableSelect'
import { MUserProfile } from '../../../models/client/profile.model'

// dummy data
const raceOptions: ISelectOptions[] = [
    CNoneOption,
    {
        name: 'White',
        value: 'White',
    },
    {
        name: 'Asian',
        value: 'Asian',
    },
    {
        name: 'Native Hawaiian',
        value: 'Native Hawaiian',
    },
    {
        name: 'American Indian or Alaskan Native',
        value: 'American Indian or Alaskan Native',
    },
    {
        name: 'Black or African American',
        value: 'Black or African American',
    },
]

const ethnicityOptions: ISelectOptions[] = [
    CNoneOption,
    {
        name: 'Hispantic  or Latino',
        value: 'Hispantic  or Latino',
    },
    {
        name: 'Not Hispanic or Latino',
        value: 'Not Hispanic or Latino',
    },
]

const genderOptions: ISelectOptions[] = [
    CNoneOption,
    {
        name: 'Male',
        value: 'MALE',
    },
    {
        name: 'Female',
        value: 'FEMALE',
    },
]

const defaultValues: any = {
    firstName: '',
    middleName: '',
    lastName: '',
    address: '',
    country: '',
    city: '',
    state: '',
    zipCode: '',
    height: '',
    weight: '',
    gender: '',
    dob: null,
    securityNumber: '',
    productImage: '',
    productImageId: '',
    POB: {
        state: '',
        stateId: '',
        city: '',
        issuingState: '',
        ethnicity: '',
        race: '',
        email: '',
        phone: '',
        smsApproval: '',
    },
    PRArray: [
        {
            state: '',
            country: '',
            city: '',
            zipCode: '',
            address: '',
        },
    ],
}

// models section
interface IProfile {
    getProfile?: () => void
    getReground: (type: string, parentId: string, stepTwo?: string) => void
    clearReground: (types: string[]) => void
    getRegroundByType: (
        type: string,
        params: ICommonQuery,
        index?: number
    ) => Promise<any>
    updateProfile: (payload: any) => Promise<any>
    clearDynamicReground: (
        types: Array<RegroundTypes>,
        arrIndex: number,
        deleteReground?: boolean
    ) => void
    setDynamicReground: (
        type: RegroundTypes,
        index: number | undefined,
        result: any
    ) => void
    getDynamicReground: (
        type: RegroundTypes,
        params: ICommonQuery,
        index: number | undefined
    ) => void
    profile?: MUserProfile
    countries: MCountry[]
    states: MState[]
    cities: MCity[]
    POB: MPOB
    user: MUser
    dynamicReground: any
}
function Profile(props: IProfile) {
    // core section
    const {
        getProfile,
        getReground,
        clearReground,
        getRegroundByType,
        updateProfile,
        clearDynamicReground,
        setDynamicReground,
        getDynamicReground,
        profile,
        countries,
        states,
        cities,
        POB,
        user,
        dynamicReground,
    } = props
    const {
        control,
        formState: { errors },
        reset,
        watch,
        setValue,
        handleSubmit,
    } = useForm({ defaultValues })
    const PRFieldsArray = useFieldArray({ control, name: 'PRArray' })
    const classesInput = 'reddit-input w-100'
    const addressInput = `${classesInput} mb-2`
    const watchImage = watch('profileImage')
    const firstRender = useRef(true)

    // states section
    const [headerActions, setHeaderActions] = useState<IPageHeaderActions[]>([
        CActions.edit,
    ])
    const [disabled, setDisabled] = useState(true)
    const [imageLoading, setImageLoading] = useState(false)

    // hooks section
    /**
     * get data from API when first load
     */
    useEffect(() => {
        if (getProfile) getProfile()
        return () => {
            APIServices.axiosCancelToken()
        }
    }, [])

    /**
     * perform API request (get reground) while profile changed
     */
    useEffect(() => {
        if (!profile?.POB) return
        const { country, state } = profile
        const POBCountry = profile?.POB?.country
        const POBState = profile?.POB?.state

        const normalRegroundCodes = `${country || 'US'}${
            state ? `|${state || ''}` : ''
        }`
        const POBRegroundCodes = `${POBCountry}${
            POBState ? `|${POBState || ''}` : ''
        }`
        APIServices.axiosConfig()
        if (normalRegroundCodes) {
            getRegroundByType('Normal', {
                codes: normalRegroundCodes,
            })
        } else {
            getReground('COUNTRY', '')
        }
        if (POBRegroundCodes) {
            getRegroundByType('POB', {
                codes: POBRegroundCodes,
            })
        }

        const mappedPRReground = profile?.PRArray?.map((item: any) => {
            let strCodes = ''
            if (item?.country) strCodes += item?.country
            if (item?.state) strCodes += `|${item?.state}`
            if (item?.city) strCodes += `|${item?.city}`
            return strCodes
        }).filter((item: any) => item)

        if (mappedPRReground?.length && firstRender?.current) {
            mappedPRReground.forEach((codes, index) => {
                getRegroundByType(' ', { codes }, index).then(
                    (response: any) => {
                        const result = response?.response?.data
                        const responseIndex = response?.index
                        _.each(result, (value, key) => {
                            const regroundType: any = key?.toUpperCase()
                            setDynamicReground(
                                regroundType,
                                responseIndex,
                                value
                            )
                        })
                    }
                )
            })
            firstRender.current = false
        }

        reset(profile)
        return () => {
            APIServices.axiosCancelToken()
        }
    }, [profile])

    /**
     * handle select change
     * @param id reground id/code
     * @param type action type (reground type CITY, COUNTRY, STATE, ...)
     * @returns
     */
    const onHandleSelect = (evt: any, type: string, index?: number) => {
        APIServices.axiosConfig()
        switch (type) {
            case 'COUNTRY':
                setValue('state', null)
                setValue('city', null)
                clearReground([EAuthReground.STATES, EAuthReground.CITIES])
                if (!evt) return
                getReground('STATE', evt)
                break
            case 'STATE':
                setValue('city', null)
                clearReground([EAuthReground.CITIES])
                if (!evt) return
                getReground('CITY', evt)
                break
            case EAuthReground.POB_STATES:
                setValue('POB.city', null)
                clearReground([EAuthReground.POB_CITIES])
                if (!evt) return
                getReground('CITY', evt, EAuthReground.POB_CITIES)
                break

            case EAuthReground.DYNAMIC_COUNTRIES:
                if (index === null || index === undefined) return
                setValue(`PRArray.${index}.state`, null)
                setValue(`PRArray.${index}.city`, null)
                clearDynamicReground(['STATE', 'CITY'], index)
                if (!evt) return
                getDynamicReground('STATE', { parentCode: evt }, index)
                break
            case EAuthReground.DYNAMIC_STATES:
                if (index === null || index === undefined) return
                setValue(`PRArray.${index}.city`, null)
                clearDynamicReground(['CITY'], index)
                if (!evt) return
                getDynamicReground('CITY', { parentCode: evt }, index)
                break
            default:
                break
        }
    }

    /**
     * handle from submit and update profile
     * @param formData inputs value
     */
    const onSubmit = (formData: any) => {
        const prResidences = formData?.PRArray?.map((item: any) => {
            let tempStr = ''
            _.each(item, (value) => {
                tempStr += value
            })
            if (!tempStr) return
            return { type: 'PR', ...item }
        }).filter((item: any) => item)
        const {
            firstName,
            lastName,
            middleName,
            profileImageId,
            profileImage,
            address,
            country,
            state,
            city,
            zipCode,
            height,
            weight,
            gender,
            dob,
            securityNumber,
            POB: POBResidence,
        } = formData
        const { username, role } = user
        const body = {
            username,
            roleId: role?.id,
            firstName,
            lastName,
            middleName,
            profileImageId,
            address,
            country,
            state,
            city,
            zipCode,
            height,
            weight,
            gender,
            dob: dob ? moment(dob).toISOString() : '',
            securityNumber,
            profileImage,
            residences: [
                {
                    type: 'POB',
                    ...POBResidence,
                },
                ...prResidences,
            ],
        }
        if (!gender) delete body?.gender
        updateProfile(body).then(() => {
            setDisabled(true)
            setHeaderActions([CActions.edit])
        })
    }

    /**
     * handle action component
     * @param action get from header action component
     */
    const handleHeaderActions = (action?: string) => {
        switch (action) {
            case 'edit':
                setDisabled(false)
                setHeaderActions([CActions.save])
                if (!POB?.states?.length) getReground('STATE', '', 'POB')

                break
            case 'save':
                handleSubmit(onSubmit)()
                break
            default:
                break
        }
    }

    const handleImageChange = (file: any) => {
        setImageLoading(true)
        CommonService.uploadImage(file)
            .then((response: any) => {
                setValue('profileImageId', response?.id)
                setValue('profileImage', response?.url)
                setImageLoading(false)
            })
            .catch(() => setImageLoading(false))
    }

    const handleRemoveProfileImage = () => {
        setValue('profileImage', '')
        setValue('profileImageId', '')
    }

    const handleRemovePR = (index: number) => {
        clearDynamicReground(['COUNTRY', 'STATE', 'CITY'], index, true)
        PRFieldsArray.remove(index)
    }

    // element section
    const PRElements = PRFieldsArray?.fields?.map((pr: any, index: number) => {
        return (
            <Fragment key={pr?.id}>
                <Controller
                    control={control}
                    name={`PRArray.${index}.country`}
                    defaultValue=""
                    // rules={{ required: true }}
                    render={({
                        field: { ref, value, onChange, ...field },
                    }: any) => (
                        <BaseCreatableSelect
                            label="Country"
                            options={countries}
                            value={value}
                            onChange={(e: any, action: any) => {
                                onChange(e)
                                onHandleSelect(
                                    e,
                                    EAuthReground.DYNAMIC_COUNTRIES,
                                    index
                                )
                            }}
                            fullWidth
                            className={addressInput}
                            error={errors?.PRArray?.[index]?.country && true}
                            helperText={FormService.getErrorMessage(
                                errors?.PRArray?.[index],
                                'country',
                                'Country'
                            )}
                            isCreatable
                            disabled={disabled}
                        />
                    )}
                />
                <Controller
                    control={control}
                    name={`PRArray.${index}.state`}
                    defaultValue=""
                    // rules={{ required: true }}
                    render={({
                        field: { ref, value, onChange, ...field },
                    }: any) => (
                        <BaseCreatableSelect
                            label="State"
                            options={dynamicReground?.states?.[index]}
                            value={value}
                            onChange={(e: any) => {
                                onChange(e)
                                onHandleSelect(
                                    e,
                                    EAuthReground.DYNAMIC_STATES,
                                    index
                                )
                            }}
                            fullWidth
                            className={addressInput}
                            error={errors?.PRArray?.[index]?.state && true}
                            helperText={FormService.getErrorMessage(
                                errors?.PRArray?.[index],
                                'state',
                                'State'
                            )}
                            disabled={disabled}
                        />
                    )}
                />
                <Controller
                    control={control}
                    name={`PRArray.${index}.city`}
                    defaultValue=""
                    // rules={{ required: true }}
                    render={({ field: { ref, value, onChange } }: any) => (
                        <BaseCreatableSelect
                            label="City"
                            options={dynamicReground?.cities?.[index]}
                            value={value}
                            onChange={(e: any) => {
                                onChange(e)
                                onHandleSelect(
                                    e,
                                    EAuthReground.DYNAMIC_CITIES,
                                    index
                                )
                            }}
                            fullWidth
                            className={addressInput}
                            error={errors?.PRArray?.[index]?.city && true}
                            helperText={FormService.getErrorMessage(
                                errors?.PRArray?.[index],
                                'city',
                                'City'
                            )}
                            disabled={disabled}
                        />
                    )}
                />
                <Controller
                    control={control}
                    name={`PRArray.${index}.zipCode`}
                    defaultValue=""
                    rules={{ minLength: 5 }}
                    render={({
                        field: { ref, value, onChange, ...field },
                    }: any) => (
                        <InputMask
                            mask="99999"
                            value={value}
                            onChange={(e: ChangeEvent<any>) => {
                                const validatedValue = e?.target?.value
                                onChange(validatedValue?.replaceAll('_', ''))
                            }}
                            className={addressInput}
                            disabled={disabled}
                        >
                            {(inputProps: any) => {
                                return (
                                    <RedditTextField
                                        {...inputProps}
                                        inputRef={ref}
                                        label="Zip Code"
                                        variant="filled"
                                        className={addressInput}
                                        error={
                                            errors?.PRArray?.[index]?.zipCode &&
                                            true
                                        }
                                        disabled={disabled}
                                        helperText={FormService.getErrorMessage(
                                            errors?.PRArray?.[index],
                                            'zipCode',
                                            'Zip Code',
                                            'Zip Code should be 5 digit'
                                        )}
                                    />
                                )
                            }}
                        </InputMask>
                    )}
                />
                <Controller
                    control={control}
                    name={`PRArray.${index}.address`}
                    defaultValue=""
                    // rules={{ required: true }}
                    render={({
                        field: { ref, value, onChange, ...field },
                    }: any) => (
                        <RedditTextField
                            {...field}
                            value={value}
                            onChange={onChange}
                            inputRef={ref}
                            label="Address"
                            variant="filled"
                            className={addressInput}
                            error={errors?.PRArray?.[index]?.address && true}
                            helperText={FormService.getErrorMessage(
                                errors?.PRArray?.[index],
                                'address',
                                'Address'
                            )}
                            onKeyPress={(e: any) =>
                                CommonService.allowsInput(e, [
                                    'alphabet',
                                    'numeric',
                                    'space',
                                ])
                            }
                            disabled={disabled}
                        />
                    )}
                />
                {PRFieldsArray?.fields?.length > 1 && !disabled ? (
                    <div className="text-right">
                        <span
                            className="custom-button-label"
                            onClick={() => handleRemovePR(index)}
                        >
                            Remove
                        </span>
                    </div>
                ) : null}
                <div className="page-divider my-18px" />
            </Fragment>
        )
    })

    // main
    return (
        <div className="profile">
            <PageHeader
                title="Profile"
                actions={headerActions}
                getActions={handleHeaderActions}
            />
            <form onSubmit={handleSubmit(onSubmit)}>
                <Grid container>
                    <Grid item md={8} sm={12}>
                        <Grid
                            container
                            direction="row"
                            justifyContent="flex-start"
                            alignItems="stretch"
                            spacing={2}
                        >
                            <Grid item md={6} xs={6}>
                                <UploadImage
                                    className="w-100 mb-3"
                                    style={{ height: 174 }}
                                    type="upload-profile"
                                    imageUrl={watchImage}
                                    disabled={disabled}
                                    remove
                                    removeAction={handleRemoveProfileImage}
                                    fileChanged={handleImageChange}
                                    isLoading={imageLoading}
                                />
                            </Grid>
                            <Grid item md={6} xs={6}>
                                <Controller
                                    control={control}
                                    name="firstName"
                                    defaultValue=""
                                    rules={{ required: true }}
                                    render={({
                                        field: {
                                            ref,
                                            value,
                                            onChange,
                                            ...field
                                        },
                                    }: any) => (
                                        <RedditTextField
                                            {...field}
                                            value={value}
                                            onChange={onChange}
                                            inputRef={ref}
                                            label="First Name"
                                            variant="filled"
                                            className={clsx(
                                                classesInput,
                                                'mb-2'
                                            )}
                                            error={errors?.firstName && true}
                                            helperText={FormService.getErrorMessage(
                                                errors,
                                                'firstName',
                                                'First Name'
                                            )}
                                            disabled={disabled}
                                        />
                                    )}
                                />
                                <Controller
                                    control={control}
                                    name="middleName"
                                    defaultValue=""
                                    // rules={{ required: true }}
                                    render={({
                                        field: {
                                            ref,
                                            value,
                                            onChange,
                                            ...field
                                        },
                                    }: any) => (
                                        <RedditTextField
                                            {...field}
                                            value={value}
                                            onChange={onChange}
                                            inputRef={ref}
                                            label="Middle Name"
                                            variant="filled"
                                            className={clsx(
                                                classesInput,
                                                'mb-2'
                                            )}
                                            error={errors?.middleName && true}
                                            helperText={FormService.getErrorMessage(
                                                errors,
                                                'middleName',
                                                'Middle Name'
                                            )}
                                            disabled={disabled}
                                        />
                                    )}
                                />
                                <Controller
                                    control={control}
                                    name="lastName"
                                    defaultValue=""
                                    rules={{ required: true }}
                                    render={({
                                        field: {
                                            ref,
                                            value,
                                            onChange,
                                            ...field
                                        },
                                    }: any) => (
                                        <RedditTextField
                                            {...field}
                                            value={value}
                                            onChange={onChange}
                                            inputRef={ref}
                                            label="Last Name"
                                            variant="filled"
                                            className={clsx(
                                                classesInput,
                                                'mb-3'
                                            )}
                                            error={errors?.lastName && true}
                                            helperText={FormService.getErrorMessage(
                                                errors,
                                                'lastName',
                                                'Last Name'
                                            )}
                                            disabled={disabled}
                                        />
                                    )}
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item md={6} sm={6} className="pt-2">
                                <Controller
                                    control={control}
                                    name="gender"
                                    defaultValue=""
                                    // rules={{ required: true }}
                                    render={({
                                        field: {
                                            ref,
                                            value,
                                            onChange,
                                            ...field
                                        },
                                    }: any) => (
                                        <BaseSelect
                                            label="Sex"
                                            options={genderOptions}
                                            value={value}
                                            onChange={onChange}
                                            fullWidth
                                            className={classesInput}
                                            error={errors?.gender && true}
                                            helperText={FormService.getErrorMessage(
                                                errors,
                                                'gender',
                                                'Sex'
                                            )}
                                            disabled={disabled}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item md={6} sm={6} className="pt-2">
                                <Controller
                                    control={control}
                                    name="country"
                                    defaultValue=""
                                    // rules={{ required: true }}
                                    render={({
                                        field: {
                                            ref,
                                            value,
                                            onChange,
                                            ...field
                                        },
                                    }: any) => (
                                        <BaseCreatableSelect
                                            label="Country"
                                            options={countries}
                                            value={value}
                                            onChange={(e: any) => {
                                                onChange(e)
                                                onHandleSelect(e, 'COUNTRY')
                                            }}
                                            fullWidth
                                            className={classesInput}
                                            error={errors?.country && true}
                                            helperText={FormService.getErrorMessage(
                                                errors,
                                                'country',
                                                'Country'
                                            )}
                                            disabled={disabled}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item md={6} sm={6} className="pt-2">
                                <Controller
                                    control={control}
                                    name="dob"
                                    defaultValue={null}
                                    // rules={{ required: true }}
                                    render={({
                                        field: {
                                            ref,
                                            value,
                                            onChange,
                                            ...field
                                        },
                                    }: any) => (
                                        <BaseDatePicker
                                            {...field}
                                            label="Date Of Birth"
                                            value={value}
                                            onChange={(e: any) => {
                                                onChange(e)
                                            }}
                                            fullWidth
                                            className={classesInput}
                                            error={errors?.dob && true}
                                            inputRef={ref}
                                            // helperText="tests"
                                            maxDate={new Date()}
                                            disabled={disabled}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item md={6} sm={6} className="pt-2">
                                <Controller
                                    control={control}
                                    name="state"
                                    defaultValue=""
                                    // rules={{ required: true }}
                                    render={({
                                        field: {
                                            ref,
                                            value,
                                            onChange,
                                            ...field
                                        },
                                    }: any) => (
                                        <BaseCreatableSelect
                                            label="State"
                                            options={states}
                                            value={value}
                                            onChange={(e: any) => {
                                                onChange(e)
                                                onHandleSelect(e, 'STATE')
                                            }}
                                            error={errors?.state && true}
                                            helperText={FormService.getErrorMessage(
                                                errors,
                                                'state',
                                                'State'
                                            )}
                                            className={classesInput}
                                            disabled={disabled}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item md={6} sm={6} className="pt-2">
                                <Controller
                                    control={control}
                                    name="weight"
                                    defaultValue=""
                                    rules={{ maxLength: 3 }}
                                    render={({
                                        field: {
                                            ref,
                                            value,
                                            onChange,
                                            ...field
                                        },
                                    }: any) => (
                                        <RedditTextField
                                            {...field}
                                            value={value}
                                            onChange={onChange}
                                            inputRef={ref}
                                            label="Weight"
                                            variant="filled"
                                            className={classesInput}
                                            error={errors?.weight && true}
                                            helperText={FormService.getErrorMessage(
                                                errors,
                                                'weight',
                                                'Weight',
                                                'Weight should less than or equal 3 digit'
                                            )}
                                            onKeyPress={(e: ChangeEvent<any>) =>
                                                CommonService.allowsInput(e, [
                                                    'numeric',
                                                ])
                                            }
                                            disabled={disabled}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item md={6} sm={6} className="pt-2">
                                <Controller
                                    control={control}
                                    name="city"
                                    defaultValue=""
                                    // rules={{ required: true }}
                                    render={({
                                        field: { ref, value, onChange },
                                    }: any) => (
                                        <BaseCreatableSelect
                                            label="City"
                                            options={cities}
                                            value={value}
                                            onChange={(e: any) => {
                                                onChange(e)
                                                onHandleSelect(e, 'CITY')
                                            }}
                                            fullWidth
                                            className={classesInput}
                                            error={errors?.city && true}
                                            helperText={FormService.getErrorMessage(
                                                errors,
                                                'city',
                                                'City'
                                            )}
                                            disabled={disabled}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item sm={6} className="pt-2">
                                <Controller
                                    control={control}
                                    name="height"
                                    defaultValue=""
                                    rules={{ minLength: 3 }}
                                    render={({
                                        field: { ref, value, onChange },
                                    }: any) => (
                                        <InputMask
                                            mask="9-99"
                                            value={value}
                                            onChange={(e: ChangeEvent<any>) => {
                                                const validatedValue =
                                                    e?.target?.value
                                                onChange(
                                                    validatedValue?.replaceAll(
                                                        '_',
                                                        ''
                                                    )
                                                )
                                            }}
                                            className={classesInput}
                                            disabled={disabled}
                                        >
                                            {(inputProps: any) => {
                                                return (
                                                    <RedditTextField
                                                        {...inputProps}
                                                        inputRef={ref}
                                                        label="Height"
                                                        variant="filled"
                                                        error={
                                                            errors?.height &&
                                                            true
                                                        }
                                                        helperText={FormService.getErrorMessage(
                                                            errors,
                                                            'height',
                                                            'Height',
                                                            'Height should be X-X or X-XX'
                                                        )}
                                                        disabled={disabled}
                                                    />
                                                )
                                            }}
                                        </InputMask>
                                    )}
                                />
                            </Grid>

                            <Grid item md={6} sm={6} className="pt-2">
                                <Controller
                                    control={control}
                                    name="address"
                                    defaultValue=""
                                    // rules={{ required: true }}
                                    render={({
                                        field: {
                                            ref,
                                            value,
                                            onChange,
                                            ...field
                                        },
                                    }: any) => (
                                        <RedditTextField
                                            {...field}
                                            value={value}
                                            onChange={onChange}
                                            inputRef={ref}
                                            label="Address"
                                            variant="filled"
                                            className={classesInput}
                                            error={errors?.address && true}
                                            helperText={FormService.getErrorMessage(
                                                errors,
                                                'address',
                                                'Address'
                                            )}
                                            disabled={disabled}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item md={6} sm={6} className="pt-2">
                                <Controller
                                    control={control}
                                    name="securityNumber"
                                    defaultValue=""
                                    // rules={{ required: true }}
                                    render={({
                                        field: {
                                            ref,
                                            value,
                                            onChange,
                                            ...field
                                        },
                                    }: any) => (
                                        <RedditTextField
                                            {...field}
                                            value={value}
                                            onChange={onChange}
                                            inputRef={ref}
                                            label="Social Security number"
                                            variant="filled"
                                            className={classesInput}
                                            error={
                                                errors?.securityNumber && true
                                            }
                                            helperText={FormService.getErrorMessage(
                                                errors,
                                                'securityNumber',
                                                'Social Security number'
                                            )}
                                            disabled={disabled}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item md={6} sm={6} className="pt-2">
                                <Controller
                                    control={control}
                                    name="zipCode"
                                    defaultValue=""
                                    // rules={{ required: true }}
                                    render={({
                                        field: {
                                            ref,
                                            value,
                                            onChange,
                                            ...field
                                        },
                                    }: any) => (
                                        <RedditTextField
                                            {...field}
                                            value={value}
                                            onChange={onChange}
                                            inputRef={ref}
                                            label="Zip Code"
                                            variant="filled"
                                            className={classesInput}
                                            error={errors?.zipCode && true}
                                            helperText={FormService.getErrorMessage(
                                                errors,
                                                'zipCode',
                                                'Zip Code'
                                            )}
                                            disabled={disabled}
                                        />
                                    )}
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item md={6}>
                                <PageHeader title="Place of birth U.S." />
                                <Controller
                                    control={control}
                                    name="POB.state"
                                    defaultValue=""
                                    // rules={{ required: true }}
                                    render={({
                                        field: {
                                            ref,
                                            value,
                                            onChange,
                                            ...field
                                        },
                                    }: any) => (
                                        <BaseCreatableSelect
                                            label="State"
                                            options={POB?.states}
                                            value={value}
                                            onChange={(e: any) => {
                                                onChange(e)
                                                onHandleSelect(e, 'POB.states')
                                            }}
                                            fullWidth
                                            className={addressInput}
                                            error={errors?.POB?.state && true}
                                            helperText={FormService.getErrorMessage(
                                                errors,
                                                'POB.state',
                                                'State'
                                            )}
                                            disabled={disabled}
                                        />
                                    )}
                                />
                                <Controller
                                    control={control}
                                    name="POB.stateId"
                                    defaultValue=""
                                    rules={{ minLength: 8 }}
                                    render={({
                                        field: {
                                            ref,
                                            value,
                                            onChange,
                                            ...field
                                        },
                                    }: any) => (
                                        <InputMask
                                            mask="a9999999"
                                            value={value}
                                            onChange={(e: ChangeEvent<any>) => {
                                                const validatedValue =
                                                    e?.target?.value
                                                onChange(
                                                    validatedValue?.replaceAll(
                                                        '_',
                                                        ''
                                                    )
                                                )
                                            }}
                                            className={classesInput}
                                            disabled={disabled}
                                        >
                                            {(inputProps: any) => {
                                                return (
                                                    <RedditTextField
                                                        {...inputProps}
                                                        inputRef={ref}
                                                        label="State ID#"
                                                        variant="filled"
                                                        className={clsx(
                                                            classesInput,
                                                            'mb-2'
                                                        )}
                                                        error={
                                                            errors?.POB
                                                                ?.stateId &&
                                                            true
                                                        }
                                                        // placeholder="[a-Z]XX-XX-XXXX"
                                                        helperText={FormService.getErrorMessage(
                                                            errors,
                                                            'POB.stateId',
                                                            'State ID#',
                                                            'State ID# should be [a-Z]XX-XX-XXX'
                                                        )}
                                                        disabled={disabled}
                                                    />
                                                )
                                            }}
                                        </InputMask>
                                    )}
                                />
                                <Controller
                                    control={control}
                                    name="POB.city"
                                    defaultValue=""
                                    // rules={{ required: true }}
                                    render={({
                                        field: { ref, value, onChange },
                                    }: any) => (
                                        <BaseCreatableSelect
                                            label="City"
                                            options={POB?.cities}
                                            value={value}
                                            onChange={(e: any) => {
                                                onChange(e)
                                                onHandleSelect(e, 'POB.cities')
                                            }}
                                            fullWidth
                                            className={addressInput}
                                            error={errors?.POB?.city && true}
                                            helperText={FormService.getErrorMessage(
                                                errors,
                                                'POB.city',
                                                'City'
                                            )}
                                            disabled={disabled}
                                        />
                                    )}
                                />
                                <Controller
                                    control={control}
                                    name="POB.issuingState"
                                    defaultValue=""
                                    // rules={{ required: true }}
                                    render={({
                                        field: { ref, value, onChange },
                                    }: any) => (
                                        <BaseCreatableSelect
                                            label="Issuing State"
                                            options={POB?.states}
                                            value={value}
                                            onChange={onChange}
                                            fullWidth
                                            className={addressInput}
                                            error={
                                                errors?.POB?.issuingState &&
                                                true
                                            }
                                            helperText={FormService.getErrorMessage(
                                                errors,
                                                'POB.issuingState',
                                                'Issuing State'
                                            )}
                                            disabled={disabled}
                                        />
                                    )}
                                />
                                <Controller
                                    control={control}
                                    name="POB.ethnicity"
                                    defaultValue=""
                                    // rules={{ required: true }}
                                    render={({
                                        field: { ref, value, onChange },
                                    }: any) => (
                                        <BaseSelect
                                            label="Ethnicity"
                                            options={ethnicityOptions}
                                            value={value}
                                            onChange={onChange}
                                            inputRef={ref}
                                            fullWidth
                                            className={addressInput}
                                            error={
                                                errors?.POB?.ethnicity && true
                                            }
                                            helperText={FormService.getErrorMessage(
                                                errors,
                                                'POB.ethnicity',
                                                'Ethnicity'
                                            )}
                                            disabled={disabled}
                                        />
                                    )}
                                />
                                <Controller
                                    control={control}
                                    name="POB.race"
                                    defaultValue=""
                                    // rules={{ required: true }}
                                    render={({
                                        field: { ref, value, onChange },
                                    }: any) => (
                                        <BaseSelect
                                            label="Race"
                                            options={raceOptions}
                                            value={value}
                                            onChange={onChange}
                                            inputRef={ref}
                                            fullWidth
                                            className={addressInput}
                                            error={errors?.POB?.race && true}
                                            helperText={FormService.getErrorMessage(
                                                errors,
                                                'POB.race',
                                                'Race'
                                            )}
                                            disabled={disabled}
                                        />
                                    )}
                                />
                                <Controller
                                    control={control}
                                    name="POB.email"
                                    defaultValue=""
                                    // rules={{ required: true }}
                                    render={({
                                        field: {
                                            ref,
                                            value,
                                            onChange,
                                            ...field
                                        },
                                    }: any) => (
                                        <RedditTextField
                                            {...field}
                                            value={value}
                                            onChange={onChange}
                                            inputRef={ref}
                                            label="Email"
                                            variant="filled"
                                            className={addressInput}
                                            error={errors?.POB?.email && true}
                                            helperText={FormService.getErrorMessage(
                                                errors,
                                                'POB.email',
                                                'Email'
                                            )}
                                            disabled={disabled}
                                        />
                                    )}
                                />
                                <Controller
                                    control={control}
                                    name="POB.phone"
                                    defaultValue=""
                                    // rules={{ required: true }}
                                    render={({
                                        field: {
                                            ref,
                                            value,
                                            onChange,
                                            ...field
                                        },
                                    }: any) => (
                                        <RedditTextField
                                            {...field}
                                            value={value}
                                            onChange={onChange}
                                            inputRef={ref}
                                            label="Telephone"
                                            variant="filled"
                                            className={addressInput}
                                            error={errors?.POB?.phone && true}
                                            helperText={FormService.getErrorMessage(
                                                errors,
                                                'POB.phone',
                                                'Telephone'
                                            )}
                                            onKeyPress={
                                                CommonService.phoneNumber
                                            }
                                            fullWidth
                                            disabled={disabled}
                                        />
                                    )}
                                />
                                <Controller
                                    control={control}
                                    name="POB.smsApproval"
                                    defaultValue=""
                                    // rules={{ required: true }}
                                    render={({
                                        field: {
                                            ref,
                                            value,
                                            onChange,
                                            ...field
                                        },
                                    }: any) => (
                                        <RedditTextField
                                            {...field}
                                            value={value}
                                            onChange={onChange}
                                            inputRef={ref}
                                            label="SMS Approval"
                                            variant="filled"
                                            className={addressInput}
                                            error={
                                                errors?.POB?.smsApproval && true
                                            }
                                            helperText={FormService.getErrorMessage(
                                                errors,
                                                'POB.smsApproval',
                                                'SMS Approval'
                                            )}
                                            disabled={disabled}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <PageHeader title="Previous Residence (10 years history)" />
                                {PRElements}
                            </Grid>
                        </Grid>
                        <Grid
                            container
                            spacing={2}
                            // direction="column"
                            className="pt-2"
                        >
                            <Grid item md={6} sm={12} className="pt-2" />
                        </Grid>
                    </Grid>
                </Grid>
            </form>
            <ChangePassword />
        </div>
    )
}

// store section
const mapStateToProps = (store: any) => {
    const { profile } = store?.client?.profile
    const { user } = store?.auth
    const { countries, POB, states, cities, dynamicReground } = store?.tempAuth

    return {
        profile,
        countries,
        states,
        cities,
        POB,
        user,
        dynamicReground,
    }
}

const mapDispatchToProps = (dispatch: Redux.Dispatch) => {
    const { getProfile, updateProfile } = ClientProfileActions
    const {
        getReground,
        clearReground,
        getRegroundByType,
        clearDynamicReground,
        setDynamicReground,
        getDynamicReground,
    } = AuthAction
    return {
        getProfile: () => dispatch(getProfile() as any),
        getReground: (type: string, parentId: string, stepTwo?: string) =>
            dispatch(getReground(type, parentId, stepTwo) as any),
        clearReground: (types: string[]) =>
            dispatch(clearReground(types) as any),
        getRegroundByType: (
            type: string,
            params: ICommonQuery,
            index?: number
        ) => dispatch(getRegroundByType(type, params, index) as any),
        updateProfile: (payload: any) =>
            dispatch(updateProfile(payload) as any),
        clearDynamicReground: (
            types: Array<RegroundTypes>,
            index: number,
            deleteReground?: boolean
        ) =>
            dispatch(clearDynamicReground(types, index, deleteReground) as any),
        setDynamicReground: (
            type: RegroundTypes,
            index: number | undefined,
            result: any
        ) => dispatch(setDynamicReground(type, index, result) as any),
        getDynamicReground: (
            type: RegroundTypes,
            params: ICommonQuery,
            index: number | undefined
        ) => dispatch(getDynamicReground(type, params, index) as any),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Profile)
